









import Vue from 'vue'
import { mapState, mapMutations } from 'vuex'
import { State, Action, Getter } from 'vuex-class'
import Component from 'vue-class-component'
import IdentifyFields from '@/components/IdentifyWizard/IdentifyFields.vue'
import IdentifyProvider from '@/components/IdentifyWizard/IdentifyProvider.vue'
import { debounce } from '@/utils/helpers'
import { createDidCodeVerification } from '@/utils/didHelpers'
import { ContextState, DidInitAuth } from '@/store/context/contextTypes'
import JavascriptAPI from '@/utils/JavascriptAPI'

// define used modules
const _CONTEXT_: string = 'context'

@Component({
  computed: {
    ...mapState({
      userDeviceExists: (state: any): boolean => state.context.userDeviceExists,
      isLoading: (state: any): boolean => state.context.isLoading
    })
  },
  components: {
    IdentifyFields,
    IdentifyProvider
  },
  watch: {
    // have to react to provider change and make a new sequence of requests to DID
    async redirectContent (currentContent: any | null, previousContent: any | null) {
      if (currentContent.id !== previousContent.id) {
        await createDidCodeVerification()
        JavascriptAPI.__REPORT_CLIENT_HEIGHT__()
      }
    }
  }
})
export default class IdentityWizard extends Vue {
  userDeviceExists: Boolean
  isLoading: Boolean
  $refs!: {
    existingDidUser: HTMLIFrameElement
  }
  @State('context') context: ContextState
  @Action('setUserWizardData', { namespace: _CONTEXT_ }) setUserWizardData: any
  @Action('lookupExistingDidUser', { namespace: _CONTEXT_ }) lookupExistingDidUser: any
  @Action('setIsLoading', { namespace: _CONTEXT_ }) setIsLoading: any
  @Action('setError', { namespace: _CONTEXT_ }) setError: any

  mounted () {
    setTimeout(() => {
      JavascriptAPI.__REPORT_CLIENT_HEIGHT__()
    }, 50)
  }

  // computed
  get showIdentifyFields () {
    const showIdentifyFields = this.userDeviceExists
    return showIdentifyFields
  }

  get showIdentifyProvider () {
    const showIdentifyProvider = !this.userDeviceExists
    return showIdentifyProvider
  }

  // Have to put this as a getter to get it working with the debounce-method
  handleInputChange (e, fieldConfig, fieldIndex) {
    return debounce(this.setInputValue(e, fieldConfig, fieldIndex), 100)
  }

  async setInputValue (e, fieldConfig, fieldIndex) {
    this.setUserWizardData({ key: e.target.id, value: e.target.value })
    if (fieldConfig.autoValidate && fieldConfig.validateMethod(e.target.value) && !this.isLoading) {
      this.setIsLoading(true)
      await createDidCodeVerification()
    }
  }

  // methods
}
